'use strict';

import ManagerService from "external-services/manager-service/manager.service";

// requiring html templates so that hot reloading works
const template = require('./bookingNotes.html');

export default function BookingNotes() {
  return {
    restrict: 'E',
    replace: true,
    template,
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      notes: '=',
      customer: '='
    },
    controller
  }
}

function controller() {
  "ngInject";

  var vm = this;

  vm.isManager = ManagerService.isManager;
}
